var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wizard-overlay",class:{activated: _vm.activated, 'bg--blue': _vm.theme === 'default', 'bg--green': _vm.theme === 'green', 'bg--gray': _vm.theme === 'gray'}},[_vm._t("default")],2),_vm._v(" "),(_vm.activated)?_c('div',{staticClass:"bg-overlay"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }